import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PROFILE_ID_LOADING = 'GET_PROFILE_ID_LOADING';
export const GET_PROFILE_ID_SUCCESS = 'GET_PROFILE_ID_SUCCESS';
export const GET_PROFILE_ID_REJECT = 'GET_PROFILE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getProfileIdLoading = () => ({ type: GET_PROFILE_ID_LOADING });
export const getProfileIdSuccess = (payload) => ({ type: GET_PROFILE_ID_SUCCESS, payload });
export const getProfileIdReject = (payload) => ({ type: GET_PROFILE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getProfileIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Profiles/web/${id}/edit`, options);
};